import { AccommodationAttributes } from '@/types'
import { UpdateAccommodationMutation } from './__generated__/update_mutation'
import { Mutation as UpdateMutation } from './update_mutation'
import { Query as EditQuery } from './edit_query'
import { EditAccommodationQuery } from './__generated__/edit_query'
import { useForm } from '@/helpers/useForm'
import { Inline as Error } from '@/components/error'
import { Inline as Loading } from '@/components/loading'
import { Query as TableQuery } from './table_query'

type Accommodation = EditAccommodationQuery['accommodations']['nodes'][0]

interface Props {
  id: string
}

export const Form = ({ id }: Props) => {
  const {
    save,
    saveSuccess,
    formBuilder,
    queryError,
    queryLoading,
    mutationLoading
  } = useForm<UpdateAccommodationMutation, AccommodationAttributes, EditAccommodationQuery, Accommodation>({
    id,
    initializer: a => ({
      ...a
    }),
    query: EditQuery,
    queryKey: 'accommodations',
    mutation: UpdateMutation,
    resultKey: 'updateAccommodation',
    refetchQueries: [TableQuery]
  })

  if (queryLoading) return <Loading />

  return (
    <>
      { queryError && <Error message={queryError} /> }
      <div className="flex flex-col gap-6">
        { formBuilder.buildQueryError() }
        { formBuilder.buildField({ name: 'Name', field: 'name', type: 'text' }) }
        <div className="grid grid-cols-3 gap-6">
          { formBuilder.buildField({ name: 'Address Line 1', field: 'address1', type: 'text' }) }
          { formBuilder.buildField({ name: 'Address Line 2', field: 'address2', type: 'text' }) }
          { formBuilder.buildField({ name: 'Address Line 3', field: 'address3', type: 'text' }) }
        </div>
        <div className="grid grid-cols-4 gap-6">
          { formBuilder.buildField({ name: 'City', field: 'city', type: 'text' }) }
          { formBuilder.buildField({ name: 'County', field: 'county', type: 'text' }) }
          { formBuilder.buildField({ name: 'Postcode', field: 'postcode', type: 'text' }) }
          { formBuilder.buildField({ name: 'Country', field: 'country', type: 'text' }) }
        </div>

        { formBuilder.saveButton(save, mutationLoading, saveSuccess) }
      </div>
    </>
  )
}
